import React from 'react';

export function KpiCard({ label, value, tone }) {
  return (
    <div className={`crm-kpi-card${tone ? ` ${tone}` : ''}`}>
      <div className="crm-kpi-label">{label}</div>
      <div className="crm-kpi-value">{value}</div>
    </div>
  );
}

export function KpiGrid({ children }) {
  return <div className="crm-kpi-grid">{children}</div>;
}

export default KpiCard;
